import { matchPath } from "react-router";
import { routeConfig } from "@monorepo/constants/routeConfig";
import { IHistoryFiltersState } from "@monorepo/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LOCATION_CHANGE, LocationChangeAction } from "connected-react-router";

const initialState = {} as IHistoryFiltersState;

const historySlice = createSlice({
  name: "history",
  initialState,
  reducers: {
    setSearchQuery(state, action: PayloadAction<string>) {
      return { ...state, searchQuery: action.payload };
    },
    setDateFilters(state, action: PayloadAction<IHistoryFiltersState["dateFilters"]>) {
      return { ...state, dateFilters: action.payload };
    },
    setActiveCart(state, action: PayloadAction<IHistoryFiltersState["activeCart"]>) {
      return {
        ...state,
        activeCart: action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(LOCATION_CHANGE, (state, action: LocationChangeAction) => {
      const { fromFilters } = (action.payload.location?.state as any) || {};

      const matchFilterPage = matchPath(action.payload.location.pathname, {
        path: [
          routeConfig.dashboard.payments.history.cartGroup.search,
          routeConfig.dashboard.payments.history.cartGroup.filter,
        ],
      });

      if (matchFilterPage?.path === routeConfig.dashboard.payments.history.cartGroup.search && !fromFilters) {
        return { ...state, dateFilters: undefined };
      }

      if (matchFilterPage?.path === routeConfig.dashboard.payments.history.cartGroup.filter && !fromFilters) {
        return { ...state, searchQuery: undefined };
      }
    });
  },
});

export const { setSearchQuery, setDateFilters, setActiveCart } = historySlice.actions;
export default historySlice.reducer;
